window.addEventListener("redtab-page:open",
  function () {
    function getCookie(cname) {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(';');
      for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }

    let transactionDetailsData = null;
    let sessionTime = 0;
    let storedCustomerPhone = null;
    let customerPhone = null;
    const transactionDetailsAPICacheExpiryTime = document.body.dataset.transactionDetailsCacheTime ? JSON.parse(document.body.dataset.transactionDetailsCacheTime) : 0;
    const customerLoggedIn = JSON.parse(getCookie("customer_logged_in"));

    let meta = sessionStorage.getItem('easyRewardsTransactionDetailsMeta');
    
    if (meta){
      const { createdAt, customerPhone } = JSON.parse(meta);
      storedCustomerPhone = customerPhone;
      if (storedCustomerPhone.startsWith('+91') && storedCustomerPhone.length > 10) {
        storedCustomerPhone = storedCustomerPhone.slice(3);
      }
      const now = Date.now();
      sessionTime = (now - createdAt) / (1000 * 60);
    }

    if (customerLoggedIn){
      const cartDrawer = document.querySelector('cart-drawer');
      customerPhone = cartDrawer?.dataset?.customerphone || '';
      if (customerPhone.startsWith('+91') && customerPhone.length > 10) {
        customerPhone = customerPhone.slice(3);
      }
      transactionDetailsData = sessionStorage.getItem('easy-rewards-transaction-details') && JSON.parse(sessionStorage.getItem('easy-rewards-transaction-details'));
      if (customerPhone != storedCustomerPhone){
        window.sessionStorage.removeItem("easy-rewards-transaction-details");
        window.sessionStorage.removeItem("easyRewardsTransactionDetailsMeta");
      }
    }

    if (transactionDetailsData == null || sessionTime > transactionDetailsAPICacheExpiryTime) {
      console.log("prefetch_transaction_details");
      async function generateHmacSha256(message, secretKey) {
        const enc = new TextEncoder();
        const key = await crypto.subtle.importKey(
          "raw",
          enc.encode(secretKey),
          { name: "HMAC", hash: "SHA-256" },
          false,
          ["sign"]
        );
        const signature = await crypto.subtle.sign("HMAC", key, enc.encode(message));
        return Array.from(new Uint8Array(signature))
        .map(b => b.toString(16).padStart(2, '0'))
        .join('');
      }
      
      async function getFreshAuth() {
        const shopPermanentDomain = "levis-india-store.myshopify.com";
        const timestamp = Date.now().toString();
        const marmeto_string_1 = timestamp.substring(0, 4);
        const marmeto_string_2 = timestamp.substring(4);
        
        const baseString = marmeto_string_1 + shopPermanentDomain + marmeto_string_2;
        const marmeto_hash = await generateHmacSha256(baseString, "yTGfof2MPlM1bLlvKSM");
        
        return {
          key: marmeto_hash,
          timestamp: timestamp,
        };
      }
      
      async function fetchTransactionDetails() {
        try {
          const { timestamp, key } = await getFreshAuth();
          if (customerPhone) {
            
            const body = {
              easy_id: customerPhone,
              store_code: "EcommerceLevis",
              country_code: "91",
            };
            
            const res = await fetch("https://leviseasyrewards.marmeto.com/api/get/customer/transaction-details", {
              method: "POST",
              keepalive: true,
              headers: {
                hash: key,
                timestamp: timestamp,
                "Content-Type": "application/json",
              },
              body: JSON.stringify(body),
            }).then(res => res.json())
            .then(data => {
                const metaData = {
                  createdAt: Date.now(),
                  customerPhone: customerPhone
                }
                window.sessionStorage.setItem('easy-rewards-transaction-details', JSON.stringify(data));
                window.sessionStorage.setItem('easyRewardsTransactionDetailsMeta', JSON.stringify(metaData));
              })
              .catch(console.error);
          }
        } catch (e) {
          console.log(e)
        }
      }
      fetchTransactionDetails();
    } else {
      console.log("local_transaction_details");
    }
});